export default "__VITE_ASSET__uO2uRA6m__"